module.exports = __webpack_public_path__ + "static/media/like.a7bf31f8.svg";